import getLogger from '@ignitesales/logger-es';
import mockPageResolutionService, { setPages, buildPageResolutionService } from './mockPageService.mjs';
import mockAnswerService from './mockAnswerService.mjs';
import mockContactService from './mockContactMeService.mjs';
import mockAppointmentService from './mockAppointmentService.mjs';
import mockNoteService from './mockNoteService.mjs';
import mockEmployeeService from './mockEmployeeLoginService.mjs';
import {storeInitialized} from "@ignitesales/neuro-application/src/stores/main-store";

const logger = getLogger({ module: 'mockServices' });

const installMocks = (opts = {}) => {
  logger.info('Attempting to install mock services.');

  if (!window.ignite) {
    throw new Error('ignite global is not available');
  }

  const pages = opts.pages || null;
  const guideDelivery = opts.isBranchGuide ? 'branch' : 'online';
  const guideType = opts.guideType || 'consumer';

  if (!pages && !pageResolutionService.ready === true) {
    throw new Error(
      'cannot install mock services as mockPageService is not ready and now pages array has been provided'
    );
  }

  if (pages) {
    setPages(pages);
  }

  window.ignite.answerService = mockAnswerService;
  window.ignite.pageResolutionService = buildPageResolutionService({guideDelivery, guideType});
  window.ignite.noteService = mockNoteService;
  window.ignite.employeeLoginService = mockEmployeeService;
  window.ignite.contactService = mockContactService;
  window.ignite.appointmentService = mockAppointmentService;
  window.ignite.appointmentSettings = {};
  logger.info('Mock services successfully installed.');
  if(opts.isBranchGuide && !mockEmployeeService.isLoggedIn()) {
    // noinspection JSIgnoredPromiseFromCall
    mockBranchLogin();
  }
};

const mockBranchLogin = async () => {
  await storeInitialized();
  window.ignite.showEmployeeDialog();
};

export {
  installMocks as default,
  mockAnswerService,
  mockAppointmentService,
  mockContactService,
  mockPageResolutionService
};
